import { get, post } from './api_base';

export const oreqGetUserOfferRequests = async (oreq_owner_user) => {
  const path = `offer-request/all/${oreq_owner_user}`;

  try {
    const getRequests = await get(path);
    return getRequests;
  } catch(err) {
    console.log('Error getting /offer-request/all: ', err);
    return err;
  }
}

export const oreqGetFields = async (oreq_owner_user, oreq_id = 'null') => {
  const path = `offer-request/${oreq_owner_user}/${oreq_id}`;

  try {
    const getRequest = await get(path);
    return getRequest;
  } catch(err) {
    console.log('Error getting /offer-request: ', err);
    return err;
  }
}

export const oreqSaveFields = async (fieldValues) => {
  const path = 'offer-request';
  const body = fieldValues;
  console.log('body: ', body);
//   const body = {
//     "oreq_owner_user": "testuser4@example.com",
//     "oreq_property_address": "test property 3",
//     "oreq_mls": "9876543",
//     "oreq_agree_upgrade_policies": "on",
//     "oreq_new_paint": "oreq_new_paint_no",
//     "oreq_paint_color": "neutral_gray_cool",
//     "oreq_paint_walls[]": "other",
//     "oreq_paint_walls_description": "test property 3 paint description",
//     "oreq_carpet": "oreq_carpet_no",
//     "oreq_carpet_option": "oreq_carpet_3",
//     "oreq_carpeting_areas[]": "other",
//     "oreq_carpeting_areas_description": "test property 3 carpet details",
//     "oreq_replace_refrigerator": "on",
//     "oreq_replace_washer": "on",
//     "oreq_replace_dishwasher": "on",
//     "oreq_replace_oven": "on",
//     "oreq_replace_countertops": "on",
//     "oreq_replace_sink": "on",
//     "oreq_replace_garbage_disposal": "on",
//     "oreq_replace_others": "on",
//     "oreq_replace_others_description": "test property 3 other appliances description",
//     "oreq_additional_comments": "test property 3 additional comments",
//     "oreq_all_residents_prequalified": "on",
//     "oreq_all_residents_viewed_property": "on",
//     "oreq_read_guidelines": "on",
//     "oreq_agree_no_purchase": "on",
//     "oreq_responsible_for_costs": "on",
//     "oreq_agree_delivery_responsibilities": "on",
//     "oreq_signature_name_1": "Mauricio Flores",
//     "oreq_signature_date_1": "13/02/25",
//     "oreq_status": "pending"
// };

console.log(body)

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /offer-request: ', err);
    return err;
  }
}
